import "react";
import { Icon } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/NoResults/NoResults.tsx
function NoResults({ iconName, text }) {
	return /* @__PURE__ */ jsxs("div", {
		className: "pt-xl flex h-full grow flex-col items-center opacity-50",
		children: [iconName && /* @__PURE__ */ jsx(Icon, {
			Icon: iconName,
			color: "neutral",
			size: "xxl"
		}), /* @__PURE__ */ jsx("span", {
			className: "text-center text-lg font-medium capitalize",
			children: text
		})]
	});
}
//#endregion
export { NoResults };

//# sourceMappingURL=NoResults.js.map